import * as Styled from "./Styles";
import Icon, { IconNames } from "../../assets/icons/Icons";
import InputButtonList from "../InputButtonList/InputButtonList";
import { ButtonType } from "../InputButton/InputButton";
import { useState } from "react";
import MoreInfoButton from "../MoreInfoButton/MoreInfoButton";
import { numberof } from "./SurveyData";

interface Props {
  data?: boolean[];
  onChange?: (data: boolean[]) => void;
}

export default function EmployeeCount(props: Props) {
  const { data = null, onChange = () => null } = props;
  const [selectedValues, setSelectedValues] = useState(data);
  const handleChanges = (values: any) => {
    setSelectedValues(values);
    onChange(values);
  };
  return (
    <Styled.QuestionWrapper>
      <Styled.Title>
        How many employees do you anticipate hiring or relocating to this market initially?.
      </Styled.Title>
      <Styled.Description>
        Depending on the number of employees or people relocating, you may have access to size
        discounts and benefits.
        <MoreInfoButton triggerChat={() => null} />
      </Styled.Description>
      <InputButtonList
        type={ButtonType.default}
        multiselect={false}
        options={numberof}
        selected={selectedValues instanceof Array ? selectedValues : null}
        onChange={(values) => handleChanges(values)}
      />
    </Styled.QuestionWrapper>
  );
}
